import React from 'react';
import {Table} from 'reactstrap';
import { setTitle } from './util';
import mfgFetch from './mfg-fetch';

class ManufacturerBilling extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            linkedPractices: [],
        };
    }

    componentDidMount() {
        setTitle("Linked Practices");

        this.getLinkedPractices()
            .then(practices => {
                if (practices) {
                    this.setState({
                        linkedPractices: practices
                    });
                }
            });
    }

    async getLinkedPractices() {
        let resp = await mfgFetch('/api/v1/mfg/linked-practices', {
            method: 'GET'
        });

        if (!resp || !resp.ok) {
            console.error('Invalid status ' + resp.statusText + ': ' + await resp.text());
            return [];
        }

        return await resp.json();
    }

    render() {

        let linkedPractices = [];

        for (let practice of this.state.linkedPractices) {
            linkedPractices.push(
                <tr>
                    <th scope="row">
                        {practice.practice_id}
                    </th>
                    <th>
                        {practice.practice_name}
                    </th>
                    <th>
                        {practice.practice_region}
                    </th>
                    <th>
                        {practice.practice_country}
                    </th>
                </tr>
            );
        }

        return (
            <div className="d-flex flex-column">
                <h3 className="section-title">Linked practices</h3>
                <Table hover>
                    <thead>
                    <th>Practice ID</th>
                    <th>Practice Name</th>
                    <th>Practice Region</th>
                    <th>Practice Country</th>
                    </thead>
                    <tbody>
                        {linkedPractices}
                    </tbody>
                </Table>
            </div>
        );
    }
}

export default ManufacturerBilling;